import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaItensAutorizados.vue?vue&type=template&id=41d12ab9&scoped=true"
import script from "./ModalSolicitacaoCirurgiaItensAutorizados.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaItensAutorizados.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaItensAutorizados.vue?vue&type=style&index=0&id=41d12ab9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d12ab9",
  null
  
)

export default component.exports